'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rxModel = require('rx-model');

var _merge = require('rxjs/observable/merge');

var _debounceTime = require('rxjs/add/operator/debounceTime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormConnect = function (_PureComponent) {
  _inherits(FormConnect, _PureComponent);

  function FormConnect(props, context) {
    _classCallCheck(this, FormConnect);

    var _this = _possibleConstructorReturn(this, (FormConnect.__proto__ || Object.getPrototypeOf(FormConnect)).call(this, props, context));

    _this.connect(props);
    return _this;
  }

  _createClass(FormConnect, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // todo: track changes for all props
      if (this.props.form !== nextProps.form) {
        this.connect(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }, {
    key: 'connect',
    value: function connect(_ref) {
      var _this2 = this;

      var form = _ref.form,
          whenForm = _ref.whenForm,
          whenModel = _ref.whenModel,
          delay = _ref.debounce;

      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      var stateObservable = form.getStateObservable();
      var attributeObservable = form.getAttributeObservable();
      var validationObservable = form.getValidationObservable();

      var observables = [];

      if (whenModel !== undefined) {
        var attributes = Array.isArray(whenModel) ? whenModel : [];

        observables.push(attributeObservable.when(attributes));
        validationObservable.when(attributes);

        if (delay > 0) {
          observables.push(validationObservable.debounceTime(delay));
        } else {
          observables.push(validationObservable);
        }
      }

      if (whenForm !== undefined) {
        var properties = Array.isArray(whenForm) ? whenForm : [];

        observables.push(stateObservable.when(properties));
      }

      this.subscription = _merge.merge.apply(undefined, observables).subscribe(function () {
        return _this2.forceUpdate();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.props.form);
    }
  }]);

  return FormConnect;
}(_react.PureComponent);

FormConnect.TICK = 33;
FormConnect.propTypes = {
  form: _propTypes2.default.instanceOf(_rxModel.Form).isRequired,
  children: _propTypes2.default.func.isRequired,
  whenForm: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.bool]),
  whenModel: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.bool]),
  debounce: _propTypes2.default.number
};
FormConnect.defaultProps = {
  debounce: FormConnect.TICK
};
exports.default = FormConnect;


//////////////////
// WEBPACK FOOTER
// ./~/react-rx-form/FormConnect.js
// module id = 729
// module chunks = 0